<template>
  <v-dialog v-model="dialog" :width="500" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          {{ 'app.user_data' | trans }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="user.name"
                              readonly
                              :label="'app.name' | trans"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="user.email"
                              :rules="rules.email"
                              required
                              :label="'app.email' | trans"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                    chips
                    v-model="user.role"
                    :items="roles"
                    :item-text="'text'"
                    :item-value="'value'"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="store" :disabled="!valid || loading" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {trans} from "../../../app";
import RulesBuilder from "../../../utils/rulesBuilder";
import axios from "axios";

export default {
  data: function () {
    return {
      dialog: false,
      valid: false,
      loading: false,
      user: {
        id: null,
        name: '',
        email: '',
        role: {value: '', text: ''},
      },
      roles: [
        {value: 'administrator', text: trans('page.roles.administrator')},
        {value: 'dietitian_premium', text: trans('page.roles.dietitian_premium')},
        {value: 'dietitian_standard', text: trans('page.roles.dietitian_standard')},
        {value: 'dietitian_student', text: trans('page.roles.dietitian_student')},
        {value: 'dietitian_inactive', text: trans('page.roles.dietitian_inactive')},
        {value: 'dietitian_test', text: trans('page.roles.dietitian_test')},
        {value: 'dietitian_education', text: trans('page.roles.dietitian_education')},
        {value: 'employee', text: trans('page.roles.employee')},
        {value: 'patient', text: trans('page.roles.patient')},
      ],
      rulesBuilder: new RulesBuilder(),
    };
  },
  props: {
    userToUpdate: null,
  },
  methods: {
    open(user) {
      this.user.id = user.id;
      this.user.name = user.name;
      this.user.email = user.email;
      this.user.role = !!user.roles ? {value: user.roles, text: trans(`page.roles.${user.roles}`)} : null;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    store() {
      this.loading = true;
      axios.patch(`/administrator/users/${this.user.id}`, {
        email: this.user.email,
        role: this.user.role.value,
      }).then(() => {
        this.$toast(trans('app.saved'));
        this.$emit('userUpdated');
      })
          .catch(e => {
            let message = trans('app.error_occurred');
            if (e.response.data.message) {
              if (trans(e.response.data.message) !== e.response.data.message) {
                message = trans(e.response.data.message);
              }
            }
            this.$toast.error(message);
          });
      this.loading = false;
      this.close();
    },
  },
  computed: {
    rules: function () {
      return {
        email: [
          ...this.rulesBuilder
              .addRequiredRule('e-mail')
              .addIsEmailRule('e-mail')
              .getRules(),
        ],
      };
    },
  },
}
</script>

<style scoped>

</style>
